module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-300.01860d964547bc9d93cf.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.woff2
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.woff2
// module chunks = styles